import { createFileRoute } from "@tanstack/react-router";
import { GroupPaymentResult } from "@/components/group-therapy/GroupPaymentResult";
import { parseEnrollmentReturn } from "@/lib/payment-return-url";

// Monri return URL of a group-therapy enrollment. Our ids live in the path;
// the query string belongs to Monri and is ignored.
export const Route = createFileRoute("/grupne-terapije/payment-result/$outcome/$enrollment")({
  component: GroupPaymentReturn,
});

function GroupPaymentReturn() {
  const { outcome, enrollment } = Route.useParams();
  return <GroupPaymentResult {...parseEnrollmentReturn({ outcome, enrollment })} />;
}
